<template>
    <div class="content">
        <div class="row">
          <div class="col">
              <app-processtable></app-processtable>
          </div>
         
        </div>
      </div>
</template>

<script>
import ProcessTable from "./process/processTable"
export default {
    components : {
        appProcesstable : ProcessTable,
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Process.vue